export enum MapView {
	NONE = 'none',
	TERRAIN = 'terrain',
	SATELLITE = 'satellite',
}